@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../host-display-block' as *;
@use '../@shared/collapsible.mixin' as *;
@use '../@shared/icon.mixin' as *;
@use '../@shared/button.mixin' as *;

@layer kol-component {
	@include kol-button-styles('kol-button');
	@include kol-icon-styles();
	.kol-details {
		.collapsible--open &__heading-button {
			.kol-icon {
				transform: rotate(90deg);
			}
		}
	}
}
